// stores/config.js
export const BASE_URL = "https://ginasafricanhairbraiding.terangapp.com/api";
